import { BASE_API } from "../constants/apis"

export const staticRelativeImageHandler = (url = "") => {
  if (url) {
    return url?.startsWith("http") ? url : `${BASE_API}/${url}`
  }
  return ""
}
